import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';
import { isPartnerGuard } from '../guards/isPartner/is-partner.guard';
import { merchantDecisionGuard } from '../guards/merchant-decision/merchant-decision.guard';

export const adminRoutes: Routes = [
  {
    path: `admin`,
    canActivate: [authGuard, clientIdGuard, isPartnerGuard],
    loadComponent: () =>
      import('../components/admin/admin.component').then(
        (m) => m.AdminComponent
      ),
    children: [
      {
        path: `users`,
        loadComponent: () =>
          import('../components/users/users.component').then(
            (m) => m.UsersComponent
          ),
        canActivate: [authGuard, clientIdGuard, isPartnerGuard],
      },
      {
        path: `users/create`,
        loadComponent: () =>
          import('../components/users/create-user/create-user.component').then(
            (m) => m.CreateUserComponent
          ),
        canActivate: [authGuard, clientIdGuard, isPartnerGuard],
      },
      {
        path: `users/edit/:selectedRecord`,
        loadComponent: () =>
          import('../components/users-edit/users-edit.component').then(
            (m) => m.UsersEditComponent
          ),
        canActivate: [authGuard, clientIdGuard, isPartnerGuard],
      },
      {
        path: `user-class`,
        loadComponent: () =>
          import('../components/user-class/user-class.component').then(
            (m) => m.UserClassComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: `user-class/create`,
        loadComponent: () =>
          import('../components/user-class-form/user-class-form.component').then(
            (m) => m.UserClassFormComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: `user-class/edit/:selectedRecord`,
        loadComponent: () =>
          import('../components/user-class-edit/user-class-edit.component').then(
            (m) => m.UserClassEditComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'merchant-groups',
        loadComponent: () =>
          import('../components/merchant-groups/merchant-groups.component').then(
            (m) => m.MerchantGroupsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'merchant-groups/create',
        loadComponent: () =>
          import(
            '../components/merchant-groups/create-merchant-groups/create-merchant-groups.component'
          ).then((m) => m.CreateMerchantGroupsComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'merchant-groups/edit/:selectedRecord',
        loadComponent: () =>
          import(
            '../components/merchant-groups/merchant-groups-edit/merchant-groups-edit.component'
          ).then((m) => m.MerchantGroupsEditComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'client',
        loadComponent: () =>
          import(
            '../components/client/client.component'
          ).then((m) => m.ClientComponent),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'mids-management',
        loadChildren: () =>
          import('./admin-mids.routes').then(m => m.ADMIN_MIDS_ROUTES),
      },
      {
        path: 'create-new-merchant',
        redirectTo: 'decision',
        pathMatch: 'full',
      },
      {
        path: 'decision',
        loadComponent: () =>
          import(
            '../components/admin/decision/decision.component'
          ).then((m) => m.DecisionComponent),
        canActivate: [authGuard, clientIdGuard, merchantDecisionGuard],
      },
      {
        path: 'single-merchant',
        loadComponent: () =>
          import(
            '../components/admin/create-new-merchant/create-new-merchant.component'
          ).then((m) => m.CreateNewMerchantComponent),
        canActivate: [authGuard, clientIdGuard],
      },
    ],
  },
];
